import {
  Attribute,
  BelongsTo,
  JsonApiModel,
  JsonApiModelConfig,
} from '@elearnio/angular2-jsonapi';

import { Course } from '@models/course.model';
import { ILTCourse } from '@models/ilt-course.model';
import { LearningPath } from '@models/learning-path.model';

// Sparse jsonb map passed through verbatim (no per-key whitelist), so pages can add
// scoped keys without a backend change; both pages write the full record so neither clobbers the other.
export interface TrainingTranslationFields {
  name?: string;
  description?: string;
  sectionTitles?: Record<string, string>;
  moduleLabels?: Record<string, string>;
}

@JsonApiModelConfig({
  type: 'training_translations',
})
export class TrainingTranslation extends JsonApiModel {
  @Attribute()
  language!: string;

  @Attribute()
  fields!: TrainingTranslationFields;

  @Attribute({ serializedName: 'training_id' })
  trainingId!: string;

  @Attribute({ serializedName: 'training_type' })
  trainingType!: string;

  // READ = URL string; WRITE = base64 data-URI.
  @Attribute({ serializedName: 'cover_image' })
  coverImage!: string | null;

  // Per-language certificate override; null = use the source-language template.
  @Attribute({ serializedName: 'certificate_template_id' })
  certificateTemplateId!: number | null;

  // "Visible to users" toggle; default-safe — always read through `active !== false`.
  @Attribute()
  active!: boolean | null;

  @Attribute({ serializedName: 'created_at' })
  createdAt!: Date;

  @Attribute({ serializedName: 'updated_at' })
  updatedAt!: Date;

  // Polymorphic parent — the canonical way to set the training on create (mirrors PublishingApproval).
  @BelongsTo({ key: 'training' })
  training!: Course | ILTCourse | LearningPath;
}
